import { isDistrictCode, isInside, isVillageCode } from '@lib/api';

/** URL keys of the district and village filters (the same on Lokasi, Tabung and Surat Jalan). */
export const AREA_KEYS = { district: 'district', village: 'village' } as const;

/**
 * The district and village a link asks for, kept only when each lies inside the level above (a hand-edited link
 * never sends a code outside its regency, and a village never stays without its district).
 */
export function areaFromParams(params: URLSearchParams, regencyCode: string): { districtCode: string; villageCode: string } {
  const d = params.get(AREA_KEYS.district);
  const v = params.get(AREA_KEYS.village);
  const districtCode = regencyCode && isDistrictCode(d) && isInside(d, regencyCode) ? d : '';
  const villageCode = districtCode && isVillageCode(v) && isInside(v, districtCode) ? v : '';
  return { districtCode, villageCode };
}

/** The URL changes of a choice one level up: what lies below it goes (`null` removes a key). */
export const AREA_CLEARED = { [AREA_KEYS.district]: null, [AREA_KEYS.village]: null } as const;
